var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Header, Input } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
var SetProbeSetSizeModal = /** @class */ (function (_super) {
    __extends(SetProbeSetSizeModal, _super);
    function SetProbeSetSizeModal(props) {
        var _this = _super.call(this, props) || this;
        _this.submit = function () {
            _this.props.postRequest("/admin/catalog/rna/organisms/id/" + encodeURIComponent(_this.props.orgId.toString()) + "/probe-set-families/id/" + encodeURIComponent(_this.props.psfId.toString()) + "/variants/id/" + encodeURIComponent(_this.props.variantId.toString()) + "/probe-set-size", {
                probeSetSize: _this.state.probeSetSize
            });
        };
        _this.onProbeSetSizeChange = function (event, data) {
            var pss = data.value;
            _this.setState({
                probeSetSize: Number(pss)
            });
        };
        _this.state = {
            probeSetSize: 0
        };
        return _this;
    }
    SetProbeSetSizeModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Header, null,
                "Current probe size - ",
                this.props.currentProbeSetSize),
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: "/probe-set-size", labelContent: React.createElement("h3", null, "Set Probe Size") },
                React.createElement(Input, { type: 'number', value: this.state.probeSetSize, onChange: this.onProbeSetSizeChange })),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, onClick: this.submit, icon: 'plus', label: 'Change Probe Size', labelPosition: 'left' }));
    };
    return SetProbeSetSizeModal;
}(React.PureComponent));
export default SetProbeSetSizeModal;
//# sourceMappingURL=SetProbeSetSizeModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/SetProbeSetSizeModal.js
// module id = 1465
// module chunks = 0